export const IncidentTypeOptions = [
    { value: 'ADVERSE_DRUG', label: 'Adverse Drug Reaction' },
    { value: 'AIRWAY', label: 'Airway Management' },
    { value: 'ANESTHESIA', label: 'Anesthesia Event' },
    { value: 'BLOOD_PRODUCT', label: 'Blood Product/Transfusion' },
    { value: 'CODE_BLUE', label: 'Code Blue/Rapid Response' },
    { value: 'COMPLAINT', label: 'Complaints/Grievances' },
    { value: 'CONSENT', label: 'Consents' },
    { value: 'DELAY', label: 'Delay of Care' },
    { value: 'DIAGNOSIS', label: 'Diagnosis/Treatment' },
    { value: 'DIAGNOSTIC_TEST', label: 'Diagnostic Test Error' },
    { value: 'DIETARY', label: 'Dietary' },
    { value: 'DISCHARGE', label: 'Discharge Issue' },
    { value: 'DOCUMENTATION', label: 'Documentation' },
    { value: 'ELOPEMENT', label: 'Elopement from Unit' },
    { value: 'EMPLOYEE_HEALTH', label: 'Employee Health' },
    { value: 'EQUIPMENT_FAILURE', label: 'Equipment failure / User failure' },
    { value: 'FACILITIES', label: 'Facilities' },
    { value: 'FALL', label: 'Fall' },
    { value: 'FALL_WITH_HARM', label: 'Fall with Harm' },
    { value: 'HEALTHCARE_IT', label: 'Healthcare I.T.' },
    { value: 'HOSPITAL_ACQUIRED_CONDITION', label: 'Hospital Acquired Condition' },
    { value: 'IMAGING', label: 'Imaging' },
    { value: 'INFECTION_CONTROL', label: 'Infection Control' },
    { value: 'IV_ACCESS', label: 'IV/Vascular Access Device' },
    { value: 'LABORATORY', label: 'Laboratory' },
    { value: 'MATERIALS_MANAGEMENT', label: 'Materials Management/Supply Chain' },
    { value: 'MEDICATION', label: 'Medication' },
    { value: 'OTHER', label: 'Other Event' },
    { value: 'PATIENT_IDENTIFICATION', label: 'Patient Identification' },
    { value: 'PATIENT_INJURY', label: 'Patient Injury' },
    { value: 'PHYSICIAN_BEHAVIOR', label: 'Physician Behavior' },
    { value: 'PRESENT_ON_ADMISSION', label: 'Present on Admission Condition' },
    { value: 'PROPERTY_LOSS', label: 'Property Loss' },
    { value: 'PROVISION_OF_CARE', label: 'Provision of Care' },
    { value: 'READMISSION', label: 'Re-admission Unplanned within 30 days' },
    { value: 'RETAINED_FOREIGN_OBJECT', label: 'Retained Foreign Object' },
    { value: 'RETURN_TO_SURGERY', label: 'Return to Surgery, Unplanned' },
    { value: 'SAFETY', label: 'Safety/Security' },
    { value: 'STERILE_PROCESSING', label: 'Sterile Processing' },
    { value: 'SURGICAL_PROCEDURE', label: 'Surgical Procedure Issue' },
    { value: 'SURGICAL_SITE_INFECTION', label: 'Surgical Site Infection' },
    { value: 'TRANSFER_TO_HIGHER_CARE', label: 'Transfer to Higher Level of Care' },
    { value: 'UTILIZATION_REVIEW', label: 'Utilization Review/Case Management' },
    { value: 'WORKPLACE_VIOLENCE', label: 'Workplace Violence' },
    { value: 'WRONG_PROCEDURE', label: 'Wrong Procedure' },
];